
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/components/theme-provider";
import { AuthProvider } from "@/contexts/AuthContext";
import { ViewAsProvider } from "@/contexts/ViewAsContext";
import { ConditionalAppLayout } from "@/components/layout/ConditionalAppLayout";
import Index from "./pages/Index";
import Dashboard from "./pages/Dashboard";
import Auth from "./pages/Auth";
import Onboarding from "./pages/Onboarding";
import Candidates from "./pages/Candidates";
import Screening from "./pages/Screening";
import Pipeline from "./pages/Pipeline";
import Jobs from "./pages/Jobs";
import Clients from "./pages/Clients";
import Leads from "./pages/Leads";
import Calendar from "./pages/Calendar";
import Analytics from "./pages/Analytics";
import Settings from "./pages/Settings";
import Messages from "./pages/Messages";
import Inbox from "./pages/Inbox";
import Automation from "./pages/Automation";
import AIHub from "./pages/AIHub";
import BetaProgram from "./pages/BetaProgram";
import ClientBizDevPage from "./pages/ClientBizDevPage";
import Integrations from "./pages/Integrations";
import Marketing from "./pages/Marketing";
import UserProfile from "./pages/UserProfile";
import { GlobalErrorBoundary } from "@/components/error-handling/GlobalErrorBoundary";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: (failureCount, error: any) => {
        if (error?.status === 401) return false;
        return failureCount < 3;
      },
    },
  },
});

function App() {
  console.log('[App] Rendering App component');
  
  return (
    <GlobalErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <TooltipProvider>
            <Toaster />
            <BrowserRouter>
              <AuthProvider>
                <ViewAsProvider>
                  <ConditionalAppLayout>
                    <Routes>
                      <Route path="/" element={<Index />} />
                      <Route path="/auth" element={<Auth />} />
                      <Route path="/onboarding" element={<Onboarding />} />
                      <Route path="/dashboard" element={<Dashboard />} />
                      <Route path="/candidates/*" element={<Candidates />} />
                      <Route path="/screening/*" element={<Screening />} />
                      <Route path="/jobs/*" element={<Jobs />} />
                      <Route path="/clients/*" element={<Clients />} />
                      <Route path="/leads/*" element={<Leads />} />
                      <Route path="/pipeline" element={<Pipeline />} />
                      <Route path="/calendar" element={<Calendar />} />
                      <Route path="/analytics" element={<Analytics />} />
                      <Route path="/settings" element={<Settings />} />
                      <Route path="/profile" element={<UserProfile />} />
                      <Route path="/inbox" element={<Inbox />} />
                      <Route path="/messaging" element={<Messages />} />
                      <Route path="/automation" element={<Automation />} />
                      <Route path="/ai-hub" element={<AIHub />} />
                      <Route path="/beta-program" element={<BetaProgram />} />
                      <Route path="/client-bizdev" element={<ClientBizDevPage />} />
                      <Route path="/marketing" element={<Marketing />} />
                      <Route path="/integrations" element={<Integrations />} />
                    </Routes>
                  </ConditionalAppLayout>
                </ViewAsProvider>
              </AuthProvider>
            </BrowserRouter>
          </TooltipProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </GlobalErrorBoundary>
  );
}

export default App;
